import { Component } from '@angular/core';

import { HisBackendService, HisNotificationService, HisUiService } from 'hisng';
import { PublicationModuleOptions } from '../../../publication-module.options';

@Component( {
    selector: 'res-publication-duplicates-search-form',
    templateUrl: './publication-duplicates-search-form.component.html'
} )
export class PublicationDuplicatesSearchFormComponent {

    public readonly moduleOptions = PublicationModuleOptions;

    constructor(
        private backendService: HisBackendService,
        private notificationService: HisNotificationService,
        private hisUiService: HisUiService
    ) { }

    doSearch() {
        console.log( 'Invoke REST service fs/res/publication/searchDuplicates' );
        this.backendService.getData( 'api/v1/fs/res/publication/searchDuplicates' ).subscribe( (result: boolean) => {
            this.notificationService.infoI18n( 'fs.res.publication.duplicates.search.started' );
            console.log( 'Backend returned', result );
        } );
    }
}
